import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { ecommerceapiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, checkingPermisson, showSortingNew, showRecords } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const Parser = require("html-react-parser");
const module = "category";
const moduleName = "Categories";
class List extends Component {
  constructor(props) {
    super(props);
    const companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || "",
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
      storeID: "",
      outletList: [],
      allowOutlet: cookie.load("clientAllowOutlet") ?? "",
      sortKey: "",
      sortValue: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
    this.loadOutlet();
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    } else if (field === "sort") {
      const valueSplit = value.split("|");
      this.setState({ sortKey: valueSplit[0], sortValue: valueSplit[1] }, () => {
        this.loadList(1);
      });
    }
  };
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, "client", this.sateValChange, this.state.currentPage, "ecom");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.storeID !== null && Object.keys(this.state.storeID).length > 0) {
      addParams += "&storeID=" + this.state.storeID.value;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    addParams += `&sortKey=${this.state.sortKey}&sortValue=${this.state.sortValue}`;
    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: ecommerceapiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        storeID: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"ecom-categories"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  {checkingPermisson(["catalogs"], "add") && (
                    <div className="col-lg-2 col-md-6 text-end">
                      <Link to={this.state.path + "/add"}>
                        <button type="button" className="btn btn-outline-primary waves-effect">
                          Add New
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input type="text" className="form-control" name="name" onChange={this.handleChangeText} value={this.state.name} />
                      <label htmlFor="name">Name</label>
                    </div>
                  </div>
                  {this.state.allowOutlet === "" && (
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                        <Select value={this.state.storeID} onChange={this.handleSelectChange.bind(this, "storeID")} placeholder="Select Outlet" isClearable={true} options={this.state.outletList} />
                        <label className="select-box-label">Outlet</label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 mt-4">{parseInt(this.state.totalPage) > 0 && showRecords(this.state.currentPage, this.state.totalRecords, moduleName)}</div>
                  </div>
                  <div className={`${this.state.listdata.length >= 5 ? "table-responsive" : ""} text-nowrap p-1 mt-2`}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Category Name{showSortingNew(this.state.sortKey, this.state.sortValue, "categoryName", this.sateValChange)}</th>
                          <th>Custom Title</th>
                          <th>Outlet Name</th>
                          <th>Availability</th>
                          <th>Sequence</th>
                          <th>Status</th>
                          {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && <th>Actions</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={5} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <strong>{item.categoryName}</strong>
                                </td>
                                <td>
                                  {item.categoryOutletID !== "" && item.categoryOutletID !== null && (
                                    <>
                                      <div data-tooltip-id={`my-tooltip${index}`}> {item.categoryOutletID.length > 30 ? item.categoryOutletID.substring(0, 30) + "..." : item.categoryOutletID}</div>
                                      {item.categoryOutletID.length > 30 && (
                                        <Tooltip id={`my-tooltip${index}`} place="left" clickable render={() => <div>{Parser(item.categoryOutletID.split(",").join("<br/>"))}</div>} />
                                      )}
                                    </>
                                  )}
                                </td>
                                <td>{item.categoryCustomTitle}</td>
                                <td>{item.categoryAvailabilityID !== "" && item.categoryAvailabilityID !== null ? item.categoryAvailabilityID : "All"}</td>
                                <td>{item.categorySequence}</td>
                                <td>{showStatus(item.categoryStatus)}</td>
                                {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && (
                                  <td>
                                    <div className="dropdown">
                                      <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                        <i className="mdi mdi-dots-horizontal"></i>
                                      </button>
                                      <div className="dropdown-menu">
                                        {checkingPermisson(["catalogs"], "edit") && (
                                          <Link to={this.state.path + "/edit/" + encodeValue(item._id)} className="dropdown-item">
                                            <i className="mdi mdi-pencil-outline me-1"></i>
                                            Edit
                                          </Link>
                                        )}
                                        {checkingPermisson(["catalogs"], "delete") && (
                                          <a className="dropdown-item" href="/" onClick={this.removeItem.bind(this, encodeValue(item._id))}>
                                            <i className="mdi mdi-trash-can-outline me-1"></i>
                                            Delete
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
